
export const RELATION = {
  CATEGORY: 'belongs to (category)',
  MADEBY: 'makes',
  SOLDBY: 'sells',
  SUBSTITUTE: 'replaces'
}